var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Card Card--image"},[_c('div',[_c('router-link',{key:_vm.id,staticClass:"Card--image-img",style:({ backgroundImage: `url('${_vm.thumbnail}')` }),attrs:{"to":{ name: 'clip', params: { id: _vm.id }}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }